import { useEffect, useRef, useState } from 'react';
import './Mapa.scss'

export default function MapaView({ admin, onClick, cruzamentos, onIdle }) {
  const mapRef = useRef()
  const [localizacaoUsuario, setLocalizacaoUsuario] = useState(null);
  const [mapaCarregado, setMapaCarregado] = useState(false);

  useEffect(() => {
    // Obter localização do usuário
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords
          setLocalizacaoUsuario({ latitude, longitude })
        },
        (err) => {
          console.log('Não foi possível obter sua localização')
        }
      );
    } else {
      console.log('Geolocalização não suportada')
    }

    let cancelled = false;
    customElements.whenDefined('gmp-map').then(() => {
      if (!cancelled) setMapaCarregado(true);
    });

    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (mapaCarregado && localizacaoUsuario) {
      const lat = localizacaoUsuario.latitude
      const lng = localizacaoUsuario.longitude

      const innerMap = mapRef.current?.innerMap
      if (!innerMap) return
      innerMap.setOptions({
        mapTypeControl: false,
        center: { lat, lng },
        zoom: 16
      });
    }
  }, [mapaCarregado, localizacaoUsuario])

  useEffect(() => {
    if (!mapaCarregado) return

    const innerMap = mapRef.current?.innerMap
    if (!innerMap) return
    // Use 'idle' event to fetch only after user stops interacting with the map
    innerMap.addListener('idle', () => {
      const bounds = innerMap.getBounds()
      if (!bounds) return

      const ne = bounds.getNorthEast()
      const sw = bounds.getSouthWest()

      const minLat = sw.lat()
      const maxLat = ne.lat()
      const minLng = sw.lng()
      const maxLng = ne.lng()

      onIdle && onIdle(minLat, maxLat, minLng, maxLng)
    })

    return () => innerMap && window.google.maps.event.clearListeners(innerMap, 'idle')
  }, [mapaCarregado])

  useEffect(() => {
    if (!mapaCarregado) return

    const markers = []
    const innerMap = mapRef.current?.innerMap
    if (!innerMap) return
    window.google.maps.importLibrary("marker").then(({ AdvancedMarkerElement, PinElement }) => {
      for (const cruzamento of cruzamentos) {
        const color = cruzamento.possuiCameras ? "#FFA500" :
          cruzamento.possuiOrdemServicoEmAberto ? "#FF0000" :
            "#0000FF"
        const pin = new PinElement({
          background: color,
          borderColor: color,
          glyphColor: "#FFFFFF",
          scale: 1,
        });

        const marker = new AdvancedMarkerElement({
          content: pin.element,
          map: innerMap,
          title: `${cruzamento.numero} - ${cruzamento.endereco}`,
          position: {
            lat: cruzamento.lat,
            lng: cruzamento.lng
          }
        })

        marker.element.style.cursor = 'pointer'
        const listener = marker.addEventListener("click", (e) => {
          onClick && onClick(cruzamento, e)
        })

        markers.push({ marker, listener })
      }
    })

    return () => {
      for (const { marker, listener } of markers) {
        marker.removeEventListener(listener)
      }
    }
  }, [cruzamentos, mapaCarregado])

  return (
    <div className={'mapa-google' + (admin ? ' mapa-google-admin' : '')}>
      <gmp-map
        ref={mapRef}
        map-id="d5026c55ab90d3d1636ea361"
        center="-23.5505,-46.6333"
        zoom="11"
      ></gmp-map>
    </div>
  )
}